import React from "react";
import LifestyleImageCard from "../shared/LifestyleImageCard";
import { getLifestyleImage } from "../../lib/lifestyleImages";

const ROUTINE = [
  {
    key: "routineMorning",
    title: "Morning spoon",
    copy: "A simple spoonful before the day starts.",
  },
  {
    key: "routineSmoothie",
    title: "Smoothie ready",
    copy: "Blend into smoothies, oats, juice or tea.",
  },
  {
    key: "routineTraining",
    title: "After training",
    copy: "Keep your fridge-ready routine simple.",
  },
];

/** Larger image-led routine cards — one job: show how gel fits the day. */
export default function HomeTrustRoutineStrip() {
  return (
    <section className="relative py-9 md:py-11 border-y border-[rgba(248,241,223,0.12)]" aria-label="Everyday routines">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-6 md:mb-7 max-w-xl mx-auto">
          <h2 className="font-sans font-semibold text-2xl md:text-3xl text-ivory m-0 leading-snug tracking-tight">
            How it fits your day
          </h2>
          <p className="mt-2 text-[15px] md:text-base text-sage m-0 leading-relaxed">
            Made fresh for real routines.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {ROUTINE.map(({ key, title, copy }) => {
            const img = getLifestyleImage(key);
            return (
              <LifestyleImageCard
                key={title}
                src={img.src}
                alt={img.alt}
                placeholderLabel={img.placeholderLabel}
                title={title}
                copy={copy}
                width={img.width}
                height={img.height}
                aspectClass="aspect-[4/5] sm:aspect-[3/4] min-h-[260px] sm:min-h-[300px] md:min-h-[340px]"
                className="w-full"
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}
